import { isDev } from '../logic';
var config = (isDev ? require('./development') : require('./production')).default;
export default config;
